import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Anchor, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";

export const SubscribeButton = ({ planId, className }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const start = async () => {
    if (!user || user.role !== "owner") {
      toast.info("Please sign in to your owner account to subscribe.");
      navigate("/portal/login", { state: { from: "/pricing" } });
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/billing/checkout", { plan_id: planId });
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={start} disabled={busy} className={className} data-testid={`pricing-cta-${planId}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Anchor className="h-4 w-4" />} Subscribe
    </button>
  );
};
